export interface PositionJournalValues {
  journalType: JournalTypeTypes
  fromAccount: string
  toAccount: string
  securityCodeType: SecurityCodeTypeTypes
  securityId: string
  quantity: number | null
  quantityDisplay?: string
  amount?: number | null
  amountDisplay?: string
  sourceAccountDescription?: string
  sourceAccountDescription2?: string
  destinationAccountDescription?: string
  destinationAccountDescription2?: string
}

export type JournalTypeTypes = 'REWARD'
export const JournalTypeText = {
  REWARD: 'Reward'
}

export type SecurityCodeTypeTypes = 'TICKER_SYMBOL' | 'CUSIP' | 'OCC_SYMBOL'
export const SecurityCodeTypeText = {
  TICKER_SYMBOL: 'Ticker Symbol',
  CUSIP: 'CUSIP',
  OCC_SYMBOL: 'OCC Symbol'
}

export interface DefaultFormValue {
  accountNumber: string
}
